<script>
  import { mapState ,mapActions } from "vuex";
  import Loading from "@/components/layout/Loading.vue";
  import SinResultados from "@/components/layout/SinResultados.vue";
  import IconOrganigrama from "@/assets/img/icon/section/IconOrganigrama.vue";

  export default {
    components: {
      Loading,
      SinResultados,
      IconOrganigrama
    },
    props: {
      id: String
    },
    data() {
      return {
        id_categoria: [],
        default_color: "#fff",
        hovered_id: "",
        id_modulo: "17",
        show_spinner: false,

        loadingOrganigrama: true
      };
    },
    created() {
      // Se ejecuta dentro del menu dado que por tiempo de ejecución no está tomando el menu
      this.getAllDocumentos();
    },
    mounted(){
    },
    computed:{
      ...mapState("OrganigramaModule", ["AllDocumentos"]), 
    },
    methods: {
      ...mapActions("OrganigramaModule", ["getDocumentos"]),

      toDatePuntos(date) {
        const newDate = new Date(date);
        newDate.setDate(newDate.getDate() + 1);
        return newDate
          .toLocaleString("es-CL", {
            day: "numeric",
            month: "numeric",
            year: "numeric",
          })
          .replace(/-/g, ".");
      },
      updateHoverState(id_) {
        this.hovered_id = id_;
      },
      async getAllDocumentos(){
        let data_ = {
          id_empresa: this.$ls.get("user").id_empresa_fk,
          id_usuario: this.$ls.get("user").id_usuario,
          id_categoria: "0",
          id_modulo: this.id_modulo,
          plataforma: "1"
        }
        this.loadingOrganigrama = true;
        await this.getDocumentos(data_);
        this.loadingOrganigrama = false;
      }
    }
  };
</script>

<template>

  <section id="organigrama">

    <div class="row">
      <div class="col-12 mb-0">
        <h1 class="h1-custom font-700 mb-1 text-capitalize color-main d-flex align-items-center">
          <IconOrganigrama class="me-2 icon-svg-45"/>
          Organigrama
        </h1>

        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link 
                to="/home"
                class="color-main"
              >
                <font-awesome-icon icon="fa-solid fa-house"></font-awesome-icon>
                Inicio
              </router-link>
            </li>
            <li class="breadcrumb-item text-capitalize active">
              Organigrama
            </li>
          </ol>
        </nav>
      </div>
    </div>

    <div class="row d-flex mt-2">
      <div class="col-12 mb-3 mb-lg-0">
        <p class="text-secondary h5-custom mb-0">
          Conoce la estructura de nuestra compañía y a quienes conforman cada uno de los equipos.
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="border-bottom mb-3 pb-3"></div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <Loading 
              v-if="loadingOrganigrama"
              pixeles="200px"
        />

        <SinResultados v-if="!loadingOrganigrama && AllDocumentos.length === 0"/>

        <div 
          v-if="!loadingOrganigrama"
          class="row"
        >
          <div
            v-for="organigrama in AllDocumentos"
            :key="organigrama.id_categoria"
            class="col-12 col-lg-4 mb-3"
          >
          <router-link
              class="card card-custom card-custom-border-hover card-shadow rounded-4 transition-all mh-120"
              :to="`/organigrama/${organigrama.id_categoria}`"
            >
              <div 
                class="card-body">
                <div class="d-flex">
                  <div class="flex-shrink-0">
                    <font-awesome-icon icon="fa-solid fa-pen-to-square" class="color-main" ></font-awesome-icon> 
                  </div>
                  <div class="flex-grow-1 ms-3">
                    <p class="text-secondary font-700 mb-0">
                      {{ organigrama.nombre }}<br>
                    <span class="text-secondary text-opacity-75 font-400 mb-0">
                      Última actualización:
                      <span>{{ organigrama.documentos.length !== 0 ? toDatePuntos(organigrama.documentos[0].fecha_creacion): "a" }}</span>
                    </span>
                    </p>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>

  </section>

</template>
